module.exports = __webpack_public_path__ + "static/media/book-in-bird-cage-400x200.v1.0800d0a7.png";